import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class BackOfANapkinInvestmentTemplateDropdownComponent extends Component {
  @tracked tippyInstance = null;

  @action setTippyInstance(e) {
    this.tippyInstance = e;
  }

  get ComponentName() {
    return this.args?.tippy ? 'Tippy' : 'empty-component';
  }
}
